var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94336 21.4715C5.17758 21.3042 5.41179 21.1369 5.62928 20.9863C8.27259 19.1126 10.7821 17.3225 14.5128 19.4974C14.7303 19.4974 14.998 19.4806 15.2824 19.4639C17.1059 19.397 19.8496 19.2966 21.1044 20.5848C21.3888 20.8692 21.5728 21.2038 21.6732 21.5886C20.385 22.676 17.0892 23.0775 15.4999 23.2448C15.3828 23.2616 15.2824 23.3619 15.2991 23.4791C15.3158 23.6129 15.4162 23.6965 15.5333 23.6798C17.2732 23.4958 21.0709 22.9939 22.2754 21.5049C22.3424 21.4213 22.3926 21.3376 22.4427 21.254C24.1492 20.0494 26.4077 18.4936 27.997 18.962C28.5658 19.1293 28.9841 19.5475 29.235 20.1833C29.302 20.3506 29.2518 20.5346 29.1012 20.635C27.813 21.5217 26.6754 22.3749 25.6716 23.111C20.753 26.7748 18.2603 28.6318 10.046 26.4737L8.42316 27.4106L4.94336 21.4715Z",
    fill: "#4E629F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0195 19.9828C22.0902 19.2969 23.5792 18.36 24.7837 18.6612C25.0347 18.7114 25.2522 18.8285 25.4362 18.979C24.2317 19.4977 23.0438 20.3509 22.2073 20.9364L22.1404 20.9866L22.0902 21.0703C22.0568 21.1372 22.0233 21.1874 21.9731 21.2543C21.856 20.8862 21.6553 20.5851 21.3876 20.3007C21.2705 20.1836 21.1534 20.0832 21.0195 19.9828Z",
    fill: "#4E629F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39446 30.5054C5.26063 30.5054 5.12679 30.4385 5.05987 30.3214L0.793768 23.0272C0.743578 22.9268 0.726849 22.8264 0.743578 22.7261C0.777038 22.6424 0.843957 22.5588 0.927606 22.4919L3.70475 20.8691C3.88878 20.7687 4.123 20.8356 4.22338 21.0029L8.48948 28.3138C8.5564 28.3975 8.5564 28.4979 8.53967 28.5982C8.50621 28.6986 8.45602 28.7823 8.35564 28.8325L5.57849 30.4552C5.51157 30.4887 5.46138 30.5054 5.39446 30.5054Z",
    fill: "#4E629F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1494 21.2591C15.9319 21.2591 15.7646 21.0918 15.7646 20.891V14.1824C15.7646 13.9649 15.9319 13.7976 16.1494 13.7976C16.3502 13.7976 16.5175 13.9649 16.5175 14.1824V20.891C16.5175 21.0918 16.3502 21.2591 16.1494 21.2591Z",
    fill: "#4E629F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2816 13.0322C15.244 13.0546 15.1763 13.0694 15.1275 13.0729C10.8703 13.9235 7.45809 11.8264 4.98104 6.80431C4.91033 6.64259 4.9149 6.4361 5.03186 6.29014C5.14883 6.14417 5.32937 6.06228 5.52822 6.09685C10.1019 6.89199 13.2561 7.74164 15.4794 12.3797C15.5389 12.5226 15.5308 12.6803 15.4626 12.8227C15.4286 12.8939 15.3569 12.9875 15.2816 13.0322Z",
    fill: "#4E629F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1493 14.5514C16.0154 14.5514 15.8816 14.4845 15.8147 14.3674L14.8504 12.8359C14.75 12.6518 14.8169 12.4176 15.001 12.3172C15.185 12.2169 15.4025 12.2838 15.5196 12.4678L16.4671 13.9826C16.5675 14.1666 16.5173 14.4008 16.3333 14.5012C16.2664 14.5347 16.1995 14.5514 16.1493 14.5514Z",
    fill: "#4E629F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5471 12.2784C17.4723 12.2561 17.3726 12.2264 17.3128 12.1542C17.1855 12.0348 17.1056 11.8481 17.1327 11.6662C17.6858 6.539 21.2733 3.43006 27.848 2.40674C28.0522 2.35911 28.2939 2.4584 28.4063 2.62763C28.5435 2.80429 28.5514 3.05089 28.4669 3.24281C25.9407 8.16116 23.8481 11.4448 17.8112 12.3029C17.7215 12.3305 17.6468 12.3082 17.5471 12.2784Z",
    fill: "#4E629F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1491 14.551C16.0822 14.551 16.0153 14.5343 15.9483 14.5008C15.7643 14.4005 15.7141 14.1662 15.8145 13.9822L17.1696 11.64C17.27 11.4727 17.5042 11.4058 17.6882 11.5062C17.8723 11.6066 17.9225 11.8408 17.8221 12.0248L16.467 14.367C16.4 14.4841 16.2662 14.551 16.1491 14.551Z",
    fill: "#4E629F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon_energy.668238c5705adb85cad855efa0a5605b.svg";
export { ForwardRef as ReactComponent };